import { render, staticRenderFns } from "./ColorGradients.vue?vue&type=template&id=6ef6d228&scoped=true&"
import script from "./ColorGradients.vue?vue&type=script&lang=js&"
export * from "./ColorGradients.vue?vue&type=script&lang=js&"
import style0 from "./ColorGradients.vue?vue&type=style&index=0&id=6ef6d228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6d228",
  null
  
)

export default component.exports